import type { DemoKey } from './keys';

export const fa: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'هندسه · 3D',
  'panel.figure': 'شکل',
  'panel.dims': 'ابعاد',
  'panel.style': 'ظاهر',
  'panel.lines': 'خط‌های ویژه',
  'style.body': 'بدنه',
  'style.line': 'خط',
  'style.cut': 'مقطع',
  'style.labels': 'برچسب رئوس',
  'group.face': 'قطرهای وجوه / مولدها',
  'group.space': 'قطرها / محورها / میانه‌ها',
  'split.label': 'مقطع',
  'btn.animate': 'انیمیشن',
  'btn.reset': 'بازنشانی',
  'hint.line1': 'برای چرخش بکشید · برای زوم اسکرول کنید',
  'hint.line2': 'برای انتخاب روی خط کلیک کنید',
  'fig.cuboid': 'مکعب مستطیل',
  'fig.cube': 'مکعب',
  'fig.triPrism': 'منشور سه‌گوش',
  'fig.hexPrism': 'منشور شش‌گوش',
  'fig.tetrahedron': 'چهاروجهی',
  'fig.squarePyramid': 'هرم چهارگوش',
  'fig.cylinder': 'استوانه',
  'fig.cone': 'مخروط',
  'fig.sphere': 'کره',
  'fig.frustumPyramid': 'هرم ناقص',
  'fig.frustumCone': 'مخروط ناقص',
  'dim.length': 'طول',
  'dim.width': 'عرض',
  'dim.height': 'ارتفاع',
  'dim.side': 'ضلع',
  'dim.radius': 'شعاع',
  'dim.r1': 'شعاع پایین',
  'dim.r2': 'شعاع بالا',
  'dim.sideBase': 'ضلع قاعده',
  'dim.sideTop': 'ضلع بالا',
  'info.face': 'وجه',
  'info.center': 'از مرکز',
  'info.diagonal': 'قطر',
  'info.axial': 'قطر محوری',
  'info.diameter': 'قطر',
  'info.generator': 'مولد',
  'info.axis': 'محور',
  'info.height': 'ارتفاع',
  'info.median': 'میانه',
  'info.apothem': 'آپوتم',
  'info.diameterBase': 'قطر قاعده',
  'info.diameterTop': 'قطر بالا',
};
